import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DxChartComponent, DxPivotGridComponent } from 'devextreme-angular';
import { exportPivotGrid } from 'devextreme/excel_exporter';
import { exportWidgets } from 'devextreme/viz/export';
import { Workbook } from 'exceljs';
import { O2PortalHycoReportService } from 'src/app/reports/o2-reports/o2-portal-hyco-report/service/o2-portal-hyco-report-service';
import saveAs from 'file-saver';
import { NotificationService } from 'src/app/common/component/notification/notification.service';
import { O2RegionalAnalysis, O2RegionalAnalysisFull } from '../types/O2RegionalAnalysis';

@Component({
  selector: 'app-o2-portal-hyco-regional-analysis-report',
  templateUrl: './o2-portal-hyco-regional-analysis-report.component.html',
  styleUrls: ['./o2-portal-hyco-regional-analysis-report.component.scss']
})
export class O2PortalHycoRegionalAnalysisReportComponent implements OnInit {
  @Input() currentYearMonthsInfo: any;
  @Input() selectedAnnouncementYear: number;
  @Input() selectedReportLinkId: number;
  billionUSDCapitalInvestmentlbl: string;
  chartColours: Map<string, string>;
  businessCapitalDataSource: any;
  fullReportDataSource: O2RegionalAnalysisFull[];
  regionalAnalysisData: O2RegionalAnalysis[];
  gridDataSOurce: any;
  asiaDataSource: any;
  northAmericaDataSource: any;
  europeDataSource: any;
  rowDataSource: any;
  isLoadPanelVisible: boolean = true;
  @ViewChild('pivotGrid', { static: false }) pivotGrid: DxPivotGridComponent;
  @ViewChild("fullchart", { static: false }) fullchart: DxChartComponent;
  @ViewChild("asiachart", { static: false }) asiachart: DxChartComponent;
  @ViewChild("nachart", { static: false }) nachart: DxChartComponent;
  @ViewChild("euchart", { static: false }) euchart: DxChartComponent;
  @ViewChild("rowchart", { static: false }) rowchart: DxChartComponent;

  constructor(private o2Svc: O2PortalHycoReportService, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.chartColours = new Map<string, string>();
    this.getFullRegionalAnalysisReportData(this.selectedReportLinkId, this.selectedAnnouncementYear);
  }

  getFullRegionalAnalysisReportData(selectedReportLinkId, selectedAnnouncementYear) {
    this.isLoadPanelVisible = true;
    this.chartColours.clear();
    this.o2Svc.getFullRegionalAnalysisReportData(selectedAnnouncementYear).subscribe({
      next: data => {
        this.fullReportDataSource = data;
        this.getRegionalAnalysisReportData(selectedAnnouncementYear);

      },
      error: error => {
        this.notificationService.alert("error", "Error while fetching Full Regional Analysis Report Data.", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  getRegionalAnalysisReportData(selectedAnnouncementYear) {
    this.o2Svc.getRegionalAnalysisReportData(selectedAnnouncementYear).subscribe({
      next: data => {
        this.regionalAnalysisData = data;
        this.regionalAnalysisData = this.getStackedDataSource(this.regionalAnalysisData);
        let billionUSDCapitalInvestment = 0;
        this.regionalAnalysisData.forEach(element => {
          billionUSDCapitalInvestment += element.competitorInvestment;
        });
        this.billionUSDCapitalInvestmentlbl = (billionUSDCapitalInvestment / 1000).toFixed(2) + " Billion USD";
        this.asiaDataSource = this.regionalAnalysisData.filter(x => x.region.toUpperCase().includes('ASIA') || x.region.toUpperCase().includes('INDIA'));
        this.northAmericaDataSource = this.regionalAnalysisData.filter(x => x.region.toUpperCase().includes('NORTH'));
        this.europeDataSource = this.regionalAnalysisData.filter(x => x.region.toUpperCase().includes('EUROPE'));
        this.rowDataSource = this.regionalAnalysisData.filter(x => x.region.toUpperCase().includes('ROW'));
        this.isLoadPanelVisible = false;
        this.gridDataSOurce = {
          fields: [{
            caption: 'Capital Investment by Competitor & Region (USD $MM)',
            width: 120,
            dataField: 'primaryBusinessType',
            expanded: true,
            area: 'row',
          }, {
            dataField: 'bigCompetitor',
            area: 'column',
          },
          {
            groupName: 'businessType',
            visible: false,
          }, {
            groupName: 'bigCompetitor',
            visible: true,
          }, {
            caption: 'USD $MM',
            dataField: 'region',
            area: 'column',
          },
          {
            caption: 'Total',
            dataField: 'competitorInvestment',
            dataType: 'number',
            summaryType: 'sum',
            area: 'data',
            format: {
              precision: Number
            }
          }],
          store: this.regionalAnalysisData
        }
      },
      error: error => {
        this.notificationService.alert("error", "Error while fetching Regional Analysis Report Data.", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  getStackedDataSource(data: O2RegionalAnalysis[]): any {
    let reduceddata = data.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.bigCompetitor == item.bigCompetitor && ai.region == item.region && ai.primaryBusinessType == item.primaryBusinessType);
      if (accItem) {
        accItem.competitorInvestment = Math.round(accItem.competitorInvestment + item.competitorInvestment);
      } else {
        accm.push(item);
      }
      return accm;
    }, []);
    return reduceddata;
  }

  customizePointRegional = (arg: any) => {
    if (!this.chartColours.has(arg.data.primaryBusinessType)) {
      this.chartColours.set(arg.data.primaryBusinessType, arg.series.pointsByArgument[arg.argument][0].getColor());
    }
    return { color: this.chartColours.get(arg.data.primaryBusinessType), hoverStyle: { color: this.chartColours.get(arg.data.primaryBusinessType) } };
  }

  customizeSidebySideChart = (arg: any) => {
    if (!this.chartColours.has(arg.seriesName)) {
      this.chartColours.set(arg.seriesName, arg.series.pointsByArgument[arg.argument][0].getColor());
    }
    return { color: this.chartColours.get(arg.seriesName), hoverStyle: { color: this.chartColours.get(arg.seriesName) } };
  }

  customizeItems(args: any) {
    let modifiedargs = [];
    args.forEach(element => {
      if ((modifiedargs.filter(x => x.text == element.text)).length == 0) {
        modifiedargs.push(element);
      }
    });
    return modifiedargs;
  }

  customizeTooltip(arg: any) {
    return {
      text: `${arg.seriesName}: ${arg.valueText}` + ' USD $MM',
    };
  }

  customizeTooltipFullChart(arg: any) {
    return {
      text: `${arg.seriesName}: ${arg.point.series.stack} : ${arg.valueText}` + ' USD $MM',
    };
  }

  onCellPrepared(e) {
    if (e.area === "data" && e.cell.text === "") {
      e.cellElement.textContent = "0";
    }
  }

  exportCharts() {
    const fullchartInstance = this.fullchart.instance;
    const asiachartInstance = this.asiachart.instance;
    const nachartInstance = this.nachart.instance;
    const euchartInstance = this.euchart.instance;
    const rowcharttInstance = this.rowchart.instance;

    exportWidgets([[fullchartInstance, asiachartInstance],
    [nachartInstance, euchartInstance],
    [rowcharttInstance]], {
      fileName: "AnnouncedCapitalByCompetitorAndRegion",
      format: "PNG"
    });

  }

  exportExcel(e) {
    const context = this;
    const workbook = new Workbook();
    const cyWorkSheet = workbook.addWorksheet("Announed Capital By Competitor and Region");
    exportPivotGrid({
      worksheet: cyWorkSheet,
      component: context.pivotGrid.instance
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'AnnouncedCapitalByCompetitorAndRegion.xlsx');
      });
    });
  }
}
